// FROM https://github.com/modusign/modusign-client/blob/277f29276cee04f83531b7861550efe10d2ffc1e/app/src/components/TextField/textAlignEnumToCSSProperty.ts

// eslint-disable-next-line import/no-unresolved
import { TextAlign } from '@modusign/react-signing/types';
import * as CSS from 'csstype';

// TODO(@DevSDK): toLowercase?
function textAlignEnumToCSSProperty(textAlign: TextAlign): CSS.Property.TextAlign {
  switch (textAlign) {
    case 'CENTER':
      return 'center';
    case 'RIGHT':
      return 'right';
    case 'LEFT':
    default:
      return 'left';
  }
}

export default textAlignEnumToCSSProperty;
